'use client'

import cn from 'classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import shared from '@booking/index.module.scss'
import styles from './index.module.scss'

import SummaryBox from '@booking/components/SummaryBox'
import HelpBox from '@booking/components/HelpBox'
import BackButton from '@booking/components/BackButton'
import DiscountBox from '@booking/components/DiscountBox'
import ErrorBox from '@booking/components/ErrorBox'

import PaymentForm from './components/PaymentForm'
import PaymentMethods from './components/PaymentMethods'
import MbWayForm from './components/MbWayForm'
import FreeContinue from './components/FreeContinue'

import ReduniqImage from './reduniq.png'
import { usePaymentFlow } from './hooks/usePaymentFlow'
import { useBookingActionsCtx, useBookingState } from '@booking/state/booking.context'

export default function PaymentProcess() {
  const t = useTranslations('booking')

  const { config } = useBookingState()
  const allowDiscountCode = config.allowDiscountCode ?? true
  const ready: boolean = true

  const { rebuildCart } = useBookingActionsCtx()

  const {
    state,
    method,
    //setMethod,
    hasFired,
    setHasFired,
    //total,
    actionUrl,
    showPaymentMethods,
    showFreeContinue,
    onPayWithCard,
    onPayWithPaypal,
    onPayWithMbWay,
    onDiscountChanged,
    onFreeContinue,
  } = usePaymentFlow({ rebuildCart })

  return (
    <div className={cn(shared.box)}>
      <div className={cn(shared.inner)}>
        <div className={cn(shared.leftColumn)}>
          {state.error ? <ErrorBox error={state.error} /> : null}

          <div className={styles.payment}>
            <BackButton />

            {allowDiscountCode ? <h2>{t('ticket.payment.title')}</h2> : null}

            <SummaryBox simple className={cn(styles.purchaseDetails)} />

            {allowDiscountCode ? (
              <DiscountBox hasFired={hasFired} onApplyOrRemove={onDiscountChanged} />
            ) : null}

            {showPaymentMethods ? <h2>{t('ticket.payment.selectMethod')}</h2> : null}

            {ready ? (
              showPaymentMethods ? (
                <PaymentMethods
                  onPayWithCard={onPayWithCard}
                  onPayWithPaypal={onPayWithPaypal}
                  onPayWithMbWay={onPayWithMbWay}
                />
              ) : null
            ) : (
              <div className={styles.loading}>
                {t('ticket.payment.loadingMethods', { default: 'Loading payment methods ...' })}
              </div>
            )}

            {method === 'card' && state.cart ? <PaymentForm action={actionUrl} /> : null}

            {method === 'mbway' ? (
              <MbWayForm hasFired={hasFired} onFire={() => setHasFired(true)} />
            ) : null}

            {showFreeContinue ? <FreeContinue onContinue={onFreeContinue} /> : null}
          </div>
        </div>

        <div className={cn(shared.rightColumn)}>
          <SummaryBox className={cn(styles.summaryBox)} />
          <HelpBox />
          <Image src={ReduniqImage} alt="" className={cn(styles.reduniq)} />
        </div>
      </div>
    </div>
  )
}
